(() => {
  const initializeMobileCartCount = () => {
    const desktopCart = document.getElementById('cart-icon-bubble');
    const mobileCount = document.querySelector('[data-cado-mobile-cart-count]');

    if (!desktopCart || !mobileCount) return;

    const mobileValue = mobileCount.querySelector('[data-cado-mobile-cart-count-value]');
    const mobileLabel = mobileCount.querySelector('[data-cado-mobile-cart-count-label]');

    const syncMobileCartCount = () => {
      const sourceBubble = desktopCart.querySelector('.cart-count-bubble');
      const sourceValue = sourceBubble?.querySelector('[aria-hidden="true"]');
      const sourceLabel = sourceBubble?.querySelector('.visually-hidden');

      mobileCount.classList.toggle('hidden', !sourceBubble);

      if (sourceValue && mobileValue) mobileValue.textContent = sourceValue.textContent;
      if (sourceLabel && mobileLabel) mobileLabel.textContent = sourceLabel.textContent;
    };

    syncMobileCartCount();
    new MutationObserver(syncMobileCartCount).observe(desktopCart, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  };

  const initializeDevNavToggle = () => {
    const STORAGE_KEY = 'cadoDevNavState';
    const toggleButton = document.querySelector('[data-cado-dev-toggle]');
    const nav = document.querySelector('.header__inline-menu[data-cado-nav-active]');

    if (!toggleButton || !nav) return;

    const labels = {
      customer: '開発用：ログイン中 → 未ログインに切替',
      guest: '開発用：未ログイン → ログイン中に切替',
    };

    const applyState = (state) => {
      nav.setAttribute('data-cado-nav-active', state);
      toggleButton.textContent = labels[state] || labels.guest;
    };

    let state = localStorage.getItem(STORAGE_KEY) || nav.getAttribute('data-cado-nav-active') || 'guest';
    applyState(state);

    toggleButton.addEventListener('click', () => {
      state = state === 'customer' ? 'guest' : 'customer';
      localStorage.setItem(STORAGE_KEY, state);
      applyState(state);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeMobileCartCount();
      initializeDevNavToggle();
    }, { once: true });
  } else {
    initializeMobileCartCount();
    initializeDevNavToggle();
  }
})();
